module.exports = __webpack_public_path__ + "img/img4_zhTc.c75934e3.png";